var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSwapVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0a1 1 0 011 1v19.586l2.293-2.293a.999.999 0 111.414 1.414l-4 3.999a.996.996 0 01-1.089.217 1.011 1.011 0 01-.326-.217l-3.999-3.999a.999.999 0 111.414-1.414L16 20.586V1a1 1 0 011-1zM6.618.077a1.001 1.001 0 011.09.217l4 3.999a.999.999 0 11-1.415 1.414L8 3.414V23a1 1 0 01-2 0V3.414L3.707 5.707a.999.999 0 11-1.414-1.414l4-3.999a1 1 0 01.325-.217z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconSwapVertical;